import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";
import useOutsideClick from "Root/hooks/useOutsideClick";
import styles from "./styles.module.scss";
const PopUp = (props) => {
    const ref = useRef(null);
    useOutsideClick(ref, () => props.close());
    return (_jsx(_Fragment, { children: _jsx(CSSTransition, { in: props.open, timeout: 360, classNames: {
                appear: styles.appear,
                enter: styles.p_up_enter,
                enterActive: styles.p_up_enter_a,
                enterDone: styles.p_up_enter_a_d,
                exit: styles.p_up_exit,
                exitActive: styles.p_up_exit_a,
                exitDone: styles.p_up_exit_a_d,
            }, children: _jsxs("div", { ref: ref, style: styles, className: styles.p_up, children: [props.text && _jsx("span", { className: styles.header, children: props.text }), props.children] }) }) }));
};
export default PopUp;
